import axios from "axios";
import { API_URL } from "../constants/api";
import ToastMsg from "../components/common/ToastMsg";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30s timeout
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor → attach token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → handle errors globally
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      // const message = error.response.data?.message || error.response.data?.detail || "Something went wrong.";

      if (status === 401) {
        ToastMsg("error", "Session expired. Please login again.");
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      } else if (status === 403) {
        ToastMsg("error", "You don’t have permission to perform this action.");
      } else {
        // ToastMsg("error", message);
      }
    } else if (error.request) {
      ToastMsg("error", "Network error. Please check your connection.");
    } else {
      console.error("Error:", error.message);
      ToastMsg("error", "Unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
